/** Enum containing all possible state of an API request */
export enum APIRequestState {
  BEFORE_START = 'BEFORE_START',
  RUNNING = 'RUNNING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}